import { TabData } from '@/components/ui/Tabs';
import { ROUTES } from '@/configs/routes';
import type { TopLevelSectionSlug } from '@/entities/OrganizationSection';

export enum TabKey {
  documents = 'documents',
  news = 'news',
  notebook = 'notebook',
  macro = 'macro',
}

const SIDEBAR_ORDER: TabKey[] = [TabKey.documents, TabKey.news, TabKey.notebook, TabKey.macro];

const TABS_BY_KEY: Record<TabKey, TabData> = {
  [TabKey.documents]: { key: TabKey.documents, value: 'Документы' },
  [TabKey.news]: { key: TabKey.news, value: 'Новости' },
  [TabKey.notebook]: { key: TabKey.notebook, value: 'Блокнот' },
  [TabKey.macro]: { key: TabKey.macro, value: 'Макро' },
};

export const getSidebarTabs = (enabledSections: TopLevelSectionSlug[]): TabData[] => {
  return SIDEBAR_ORDER.filter((tabKey) => enabledSections.includes(tabKey)).map((tabKey) => TABS_BY_KEY[tabKey]);
};

export const getTabRoute = (key: TabKey, organizationId: number) => {
  switch (key) {
    case TabKey.documents:
      return ROUTES.organization.documents.create(organizationId.toString());
    case TabKey.news:
      return ROUTES.organization.news.create(organizationId.toString());
    case TabKey.notebook:
      return ROUTES.organization.notebook.create(organizationId.toString());
    case TabKey.macro:
      return ROUTES.organization.macro.create(organizationId.toString());
  }
};
